import { parseJson } from '@/utils/parseJson';

const getContainerRatio = (mobileVideoInfo: string) => {
  const mobileVideoInfoJson = parseJson(mobileVideoInfo);
  const { width, height } = mobileVideoInfoJson ?? {};
  if (!width || !height || width <= 0 || height <= 0) return 'auto';
  return `${width} / ${height}`;
};

export default getContainerRatio;
